import { SystemCurrency } from '@okletsplay/core/src/modules/payment/enums/system-currency';
import { createEntityAdapter } from '@reduxjs/toolkit';
import { UserBalanceDto } from 'app/interfaces/dto';
import { UserPaymentAccountsStoreStatus } from './enums';
import { UserPaymentAccountsState } from './interfaces';

const DEFAULT_USER_BALANCE = 1;

export const entityAdapter = createEntityAdapter<UserBalanceDto>({
  selectId: (data) => data.currency,
});

export const initialState: UserPaymentAccountsState = entityAdapter.getInitialState({
  ids: [SystemCurrency.OKLP, SystemCurrency.USDT],
  entities: {
    [SystemCurrency.OKLP]: {
      currency: SystemCurrency.OKLP,
      balance: DEFAULT_USER_BALANCE,
      depositAddress: '',
    },
    [SystemCurrency.USDT]: {
      currency: SystemCurrency.USDT,
      balance: DEFAULT_USER_BALANCE,
      depositAddress: '',
    },
  },
  status: {
    [UserPaymentAccountsStoreStatus.Loading]: [],
  },
});
